export const columns = [
  {
    columnId: 1,
    name: "订单操作",
    key: "handle",
    minWidth: "120",
  },
  {
    columnId: 2,
    name: "订单编号",
    key: "splitOrderId",
    minWidth: 70,
  },
  {
    columnId: 3,
    name: "用户ID",
    key: "userName",
    minWidth: 90,
  },
  {
    columnId: 4,
    name: "采购/检品工作签",
    key: "staffRemark",
    minWidth: 160,
  },
  {
    columnId: 5,
    name: "PDF文件/检品文件",
    key: "pdfUrl",
    minWidth: 160,
  },
  /*{
    columnId: 5,
    name: "检品报告书",
    key: "pdfUrl",
    minWidth: 160,
  },*/
  {
    columnId: 6,
    name: "中/英产品描述",
    key: "productDesc",
    minWidth: 160,
  },
  {
    columnId: 7,
    name: "国内物流",
    key: "trackingNumberCn",
    minWidth: 150,
  },
  // {
  //     columnId: 6,
  //     name: "国际物流",
  //     key: "trackingNumberJpn",
  //     minWidth: 150,
  // },
  {
    columnId: 8,
    name: "中国运费",
    key: "chineseFreightFee",
    minWidth: 90,
  },
  {
    columnId: 9,
    name: "单价",
    key: "price",
    minWidth: 90,
  },
  {
    columnId: 25,
    name: "商品总金额",
    key: "sumPrice",
    minWidth: 90,
  },
  {
    columnId: 10,
    name: "用户备注",
    key: "customerRemark",
    minWidth: 160,
  },
  {
    columnId: 11,
    name: "购买订单号",
    key: "buyOrderNumber",
    minWidth: 170,
  },
  {
    columnId: 12,
    name: "购买账号",
    key: "buyAccountId",
    minWidth: 170,
  },
  {
    columnId: 13,
    name: "订单状态",
    key: "orderStatus",
    minWidth: 80,
  },
  // {
  //   columnId: 14,
  //   name: "FBA/YFF/ZOZO/RSL",
  //   key: "isFBA",
  //   minWidth: 225,
  // },
  {
    columnId: 14,
    name: "发送方式",
    key: "route",
    minWidth: 100,
  },
  {
    columnId: 15,
    name: "商品数量",
    key: "goodsCount",
    minWidth: 120,
  },
  {
    columnId: 16,
    name: "检品",
    key: "inspection",
    minWidth: 150,
  },
  {
    columnId: 17,
    name: "仓库保管",
    key: "categoryFlag",
    minWidth: 70,
  },
  {
    columnId: 18,
    name: "库位",
    key: "locatorNo",
    minWidth: 80,
  },
  {
    columnId: 19,
    name: "包装意向",
    key: "putIntent",
    minWidth: 70,
  },
  {
    columnId: 20,
    name: "代为购买",
    key: "agentFlag",
    minWidth: 70,
  },
  {
    columnId: 21,
    name: "创建时间",
    key: "createTime",
    minWidth: 90,
  },
  {
    columnId: 22,
    name: "商品信息",
    key: "goodsInfo",
    // minWidth: 500,
    minWidth: "220",
    width: "220px", // 新增宽度
  },
  {
    columnId: 23,
    name: "图片",
    key: "picture",
    minWidth: "80",
  },
  {
    columnId: 24,
    name: "不良待处理",
    key: "badCount",
    minWidth: "120",
  },
  /*    {
        columnId: 25,
        name: "检品视频",
        key: "playVideo",
        minWidth: "120",
    },*/

  {
    columnId: 26,
    name: "检品系数",
    key: "checkCoefficient",
    minWidth: "120",
  },
  {
    columnId: 27,
    name: "检品报告书",
    key: "checkReport",
    minWidth: 120,
  },
  {
    columnId: 28,
    name: "支付方式",
    key: "payMethod",
    minWidth: "90",
  },
  {
    columnId: 29,
    name: "收货地址",
    key: "receiver",
    minWidth: "215",
  },
];
